// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-193de50e","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=1!./~/iview-loader?{"prefix":false}!./src/views/home-page/layout.vue
// module id = 1201
// module chunks = 61